<template>
  <div id="app">
    <div class="changeLunguageButton">
      <a v-if="this.$store.state.num == 2 || this.$store.state.num == null" @click="changeLanguage(1)" class="ignore">Switch to English</a>
      <a v-if="this.$store.state.num == 1" @click="changeLanguage(2)" class="ignore">切换中文</a>
    </div>
    <router-view />
  </div>
</template>
<script>
// import translate from 'i18n-jsautotranslate'



export default {
  name: "App",
  data() {
    return {
      language: this.$store.state.num
    }
  },
  created() {
    if(sessionStorage.getItem('num') != null){
      this.$store.commit('editTitle', { num: sessionStorage.getItem('num') })
    }
    // window.translate = translate; //方便审核元素用控制台调试
    // translate.service.use('client.edge'); //翻译通道
    // translate.whole.enableAll(); //整体翻译
    // translate.listener.start();    //开启html页面变化的监控
    // translate.selectLanguageTag.languages = 'english,chinese_simplified';
    //页面渲染完毕后触发执行 translate.execute(); 

  },
  //页面渲染完毕后触发执行 translate.execute(); 

  mounted() {
    setTimeout(() => {
      if (this.$store.state.num == 1) {
        document.title = 'Xingwen UNESCO Global Geopark'
      } else {
        document.title = '兴文世界地质公园'
      }
    }, 1000);
    // this.language = sessionStorage.getItem('num')
    // setTimeout(() => {
    //   this.handleEvent()
    // }, 500);

  },
  methods: {
    // handleEvent() {
    //   translate.execute();
    // },
    changeLanguage(num) {
      sessionStorage.setItem('num',num)
      this.$store.commit('editTitle', { num: num })
      this.language = num
      if (num == 1) {
        document.title = 'Xingwen UNESCO Global Geopark'
      } else {
        document.title = '兴文世界地质公园'
      }
      // sessionStorage.setItem('num',num)
      // translate.changeLanguage(e);
      // window.location.reload()
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
}
</style>
<style lang="scss">

.changeLunguageButton {
  background-color: #fff;
  width: 120px;
  height: 30px;
  line-height: 30px;
  position: fixed;
  z-index: 9999;
  right: 0;
  top: 0vh;
}

#translate {
  display: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
